$(document).ready(() => {
  const $cpfCnpjInput = $('.search-account-form__cpf_cnpj');
  const CPF_LENGTH = 14;
  const CNPJ_LENGTH = 18;

  function ApplyCpfCnpjMask() {
    if ($cpfCnpjInput.val().length <= CPF_LENGTH) {
      $cpfCnpjInput.mask('AAA.AAA.AAA-AAA-AA', { reverse: false });
    } else {
      $cpfCnpjInput.mask('AA.AAA.AAA/AAAA-00', { reverse: false });
    }
  }

  function EnableDisableSubmit() {
    const $submitButton = $('.search-account-form__submit');

    const hasCpfOrCnpjLength = $cpfCnpjInput.val().length === CPF_LENGTH || $cpfCnpjInput.val().length === CNPJ_LENGTH;

    $submitButton.prop('disabled', !hasCpfOrCnpjLength);
  }

  $cpfCnpjInput.on('keyup', () => {
    if ($cpfCnpjInput.val() !== undefined && $cpfCnpjInput.val() !== null) {
      ApplyCpfCnpjMask();
      EnableDisableSubmit();
    }
  });

  if ($cpfCnpjInput.val() !== undefined && $cpfCnpjInput.val() !== null) {
    ApplyCpfCnpjMask();
    EnableDisableSubmit();
  }
});
